var calendar = false;
var calendar_initial_view = 'timeGridWeek';

const event_filter = {
    data:{
        debounce: false,
    },
    q: (_this) => {
        if(jQuery(_this).data('old-value') == jQuery(_this).val()){
            return;
        }
        if(!event_filter.data.debounce){
            clearTimeout(event_filter.data.debounce);
            event_filter.data.debounce = setTimeout(() => {
                jQuery('.event-search').trigger('submit');
            },1000);
        }
    },
    clear: (_this) => {
        jQuery(_this).parent('.input').find('input').val('');
        jQuery('.event-search').trigger('submit');
    },
    datepicker_init: (start_date, end_date) => {
        jQuery('input.datepicker').daterangepicker(
            {
                "autoApply": true,
                "locale": {
                    "format": "YYYY. MM. DD",
                    "separator": " - ",
                    "applyLabel": "Ok",
                    "cancelLabel": "Mégsem",
                    "fromLabel": "Kezdő",
                    "toLabel": "Vég",
                    "customRangeLabel": "Egyedi",
                    "weekLabel": "H",
                    "daysOfWeek": [
                        "V",
                        "H",
                        "K",
                        "Sze",
                        "Cs",
                        "P",
                        "Szo"
                    ],
                    "monthNames": [
                        "Január",
                        "Február",
                        "Március",
                        "Április",
                        "Május",
                        "Június",
                        "Július",
                        "Augusztus",
                        "Szeptember",
                        "Octóber",
                        "November",
                        "December"
                    ],
                    "firstDay": 1
                },
                "startDate": start_date != 'false' ? start_date : new Date(),
                "endDate": end_date != 'false' ? end_date : new Date(),
            }, function(start, end, label) {
                jQuery('.event-search input[name="ds"]').val(start.format('YYYY-MM-DD'));
                jQuery('.event-search input[name="de"]').val(end.format('YYYY-MM-DD'));
                jQuery('.event-search').submit();

            }
        );
        if(start_date != 'false' && end_date != 'false'){
            jQuery('.event-search input[name="ds"]').val(start_date);
            jQuery('.event-search input[name="de"]').val(end_date);
        }else{
            jQuery('.event-search input.datepicker').val('');
        }
    },

    setParam: (name, value) => {
        let params = window.location.search;
        if(params == ''){
            window.location.search = '?' + name + '=' + value;
        }
    }
};

const eventHelper = {
    data: {
        url: true
    },

    initCalendar: (initial_date) => {
        document.addEventListener('DOMContentLoaded', function() {
            var calendarEl = document.getElementById('calendar');
            calendar = new FullCalendar.Calendar(calendarEl, {
                initialView: calendar_initial_view,
                stickyHeaderDates: false,
                // timeZone: 'UTC',
                height: 'auto',
                headerToolbar: {
                    left: 'title',
                    right: 'customprev,customtoday,customnext',
                },
                locale: 'hu',
                allDayText: '',
                initialDate: initial_date,
                slotLabelFormat: { // like '14:30'
                    hour: '2-digit',
                    minute: '2-digit',
                    meridiem: false,
                    hour12: false

                },
                eventTimeFormat: { // like '14:30'
                    hour: '2-digit',
                    minute: '2-digit',
                    meridiem: false,
                    hour12: false

                },
                // expandRows: true,
                slotDuration: '00:30:00',
                snapDuration: '00:30:00',
                slotMinTime: '06:00:00',
                slotMaxTime: '24:59:00',
                slotEventOverlap: true,
                titleFormat: {
                    year: 'numeric',
                    month: 'long'
                },
                dayHeaderFormat: {
                    weekday: 'long',
                    day: 'numeric',
                    omitCommas: true
                },

                customButtons: {
                    customprev: {
                        text: 'Balra nyíl',
                        click: function() {
                            calendar.prev();
                        }
                    },
                    customtoday: {
                        text: 'Ez a hét',
                        click: function() {
                            calendar.today();
                        }
                    },
                    customnext: {
                        text: 'Jobbra nyíl',
                        click: function() {
                            calendar.next();
                        }
                    }
                },

                dayHeaderContent: (args) => {
                    let text = args.text.split(' ');
                    let date = args.date.getFullYear() + '-' + args.date.getMonth() + '-' + args.date.getDate();
                    let current_date = new Date();
                    
                    var short = text[1].charAt(0).toUpperCase();
                    if(text[1] == 'szerda'){
                        short = 'Sze';
                    }

                    if(text[1] == 'szombat'){
                        short = 'Szo';
                    }

                    if(text[1] == 'csütörtök'){
                        short = 'Cs';
                    }

                    if(date == current_date.getFullYear() + '-' + current_date.getMonth() + '-' + (current_date.getDate() - 1)){
                        text[1] = 'Tegnap';
                    }
                    if(date == current_date.getFullYear() + '-' + current_date.getMonth() + '-' + current_date.getDate()){
                        short =  text[1] = 'Ma';
                        
                    }
                    if(date == current_date.getFullYear() + '-' + current_date.getMonth() + '-' + (current_date.getDate() + 1)){
                        text[1] = 'Holnap';
                    }


                    return {html: '<div class="short-title">' + short + '</div><div class="title">' + text[1].charAt(0).toUpperCase() + text[1].slice(1) + '</div><div class="date">' + text[0].replace('.', '') + '</div>'};
                },
                eventContent : (args) => {
                    if(args.event._def.extendedProps.locate != undefined){
                        let time = (args.event.start.getHours() < 10 ? '0' : '') + args.event.start.getHours() + ':' + (args.event.start.getMinutes() < 10 ? '0': '') + args.event.start.getMinutes();
                        return {html: '<div><span class="time">' + time + '</span><span class="type">' + args.event._def.extendedProps.type + '</span></div><div class="title">' + args.event._def.title + '</div><div class="locale">' + args.event._def.extendedProps.locate + '</div>'};
                    }else{
                        return {html: '<div class="title">' + args.event._def.title + '</div>'};
                    }
                },
                events: events,
            });
        });
    },
    
    init : () => {
        jQuery('#events-data-list .full-day').addClass('d-none');
        calendar.render();
        jQuery('#events-calendar .fc-timegrid-cols').append('<div id="calendar-now-indicator"></div>');
        var date = new Date();
        var time = (date.getHours() < 10 ? '0' : '') + date.getHours() + ':00:00';
        jQuery('#events-calendar .fc-timegrid-slot-label[data-time="' + time + '"] .fc-timegrid-slot-label-cushion').addClass('current');
        if(typeof jQuery('#events-calendar .fc-timegrid-slot-label[data-time="' + time + '"] .fc-timegrid-slot-label-cushion').offset() !== 'undefined' || typeof jQuery('#events-calendar .fc-timegrid-cols').offset() !== 'undefined' || typeof jQuery('#events-calendar .fc-timegrid-slot-label[data-time="' + time + '"] .fc-timegrid-slot-label-cushion').outerHeight(true)  !== 'undefined'){
            jQuery('#events-calendar #calendar-now-indicator').css('top', jQuery('#events-calendar .fc-timegrid-slot-label[data-time="' + time + '"] .fc-timegrid-slot-label-cushion').offset().top - jQuery('#events-calendar .fc-timegrid-cols').offset().top + (jQuery('#events-calendar .fc-timegrid-slot-label[data-time="' + time + '"] .fc-timegrid-slot-label-cushion').outerHeight(true) / 2));
        }
        else{
            jQuery('#events-calendar #calendar-now-indicator').css('top', -1000)
        }

        var events = jQuery('#events-calendar a.fc-v-event');
        events.each(function(){
            jQuery(this).height(jQuery(this).find('.fc-event-main').outerHeight(true));
        });

        calendar_initial_view = eventHelper.calendarResize(calendar, calendar_initial_view);

        jQuery(window).resize(function(){
            calendar_initial_view = eventHelper.calendarResize(calendar, calendar_initial_view);
        });
    },
    navigator: (url, redirect) => {
        if(eventHelper.data.url){
            eventHelper.data.url = false;
            if(redirect){
                window.location.href = url;
            }
            setTimeout(() => {eventHelper.data.url = true;}, 1000);
        }
    },
    changeView: (type) => {
        jQuery('.event-search input[name="pv"]').val(type);
        jQuery('.event-search').trigger('submit');
    },
    openFilter: () => {
        jQuery('.event-search').addClass('active');
    },
    closeFilter: () => {
        jQuery('.event-search').removeClass('active');
    },
    
    calendarResize(calendar, calendar_initial_view){
        if(jQuery(window).width() < 768 && calendar_initial_view != 'timeGridDay'){
            if(calendar){
                calendar.changeView('timeGridDay');
            }
            calendar_initial_view = 'timeGridDay';
            jQuery('#events-data-list .full-day').removeClass('d-none');
        }else if(jQuery(window).width() >= 768 && calendar_initial_view != 'timeGridWeek'){
            if(calendar){
                calendar.changeView('timeGridWeek');
            }
            calendar_initial_view = 'timeGridWeek';
            jQuery('#events-data-list .full-day').addClass('d-none');
        }

        return calendar_initial_view;
    }
};